export const chatApiPaths = {
  getStreamToken: '/chatservice/chats/token',
  userNotificationPreferences: '/chatservice/user-notification-preferences',
} as const;

export const getChatApiUrl = {
  getStreamToken: () => chatApiPaths.getStreamToken,
  userNotificationPreferences: () => chatApiPaths.userNotificationPreferences,
};
